<template>
  <reference-sidesheet
    ref="modal"
    :sidesheet-header="id ? 'Редактирование типа документа' : 'Новый тип документа'"
    :display-actions="!!id"
    @onSubmit="onSubmit"
    @onReset="onReset"
  >
    <u-confirm id="delete-doctype" ref="confirm" />

    <template #sidesheet-actions>
      <div v-if="id && savedData.docs" class="layout-header-action">
        <span id="doctype-remove-wrapper-sidesheet" class="documents-group__remove">
          <c-button-2
            size="small"
            label="Удалить"
            :disabled="savedData.docs.length > 0"
            :icon="{
              icon: 'trash',
              color: 'secondary',
            }"
            @click="deleteDocumentType"
          />
        </span>
        <b-popover
          v-if="savedData.docs.length > 0"
          placement="top"
          triggers="hover blur"
          :target="'doctype-remove-wrapper-sidesheet'"
        >
          <error-feedback
            class="m-0 empty-category-tooltip"
            text="В данный момент удаление невозможно, так как тип содержит документы. Сначала перенесите все документы из типа."
          ></error-feedback>
        </b-popover>
      </div>
    </template>

    <div class="doctype-form">
      <div class="doctype-form__name" :style="{ 'margin-bottom': submitted && nameError ? '60px' : '40px' }">
        <c-input-2
          v-model="form.name"
          floating-label="Наименование документа"
          :required="submitted && nameError"
          :required-message="submitted && nameError"
          :required-mark="true"
          :max-length="500"
          :clearable="true"
        ></c-input-2>
      </div>

      <div class="doctype-form__description">
        <c-textarea
          ref="description"
          v-model="form.description"
          floating-label="Описание"
          type="textarea"
          :max-length="500"
          :clearable="true"
        ></c-textarea>
      </div>
    </div>

    <div class="doctype-form-issues">
      <h2>Проблемы с документами</h2>
      <div class="doctype-form-issues__colors">
        <div class="doctype-form-issues__color">
          <document-color
            ref="absentColor"
            v-model="form.absentColor"
            :validate="submitted"
            label="Цвет отсутствующего документа"
            default-color="#FF0000"
          ></document-color>
        </div>
        <div class="doctype-form-issues__color">
          <document-color
            ref="expiredColor"
            v-model="form.expiredColor"
            :validate="submitted"
            label="Цвет истекшего срока годности"
            default-color="#FF238D"
          ></document-color>
        </div>
        <div class="doctype-form-issues__color">
          <document-color
            ref="expiringColor"
            v-model="form.expiringColor"
            :validate="submitted"
            label="Цвет истекающего срока годности"
            default-color="#FFB800"
          ></document-color>
        </div>
      </div>
    </div>
  </reference-sidesheet>
</template>

<script>
import ReferenceSidesheet from "@/components/reference-components/reference-sidesheet";
import Input2 from "@/components/controls2/Input";
import Button2 from "@/components/controls2/Button";
import Textarea from "@/components/textarea";
import DocumentColor from "./document-color";
import Confirm from "@/pages/documents/u-confirm";
import ErrorFeedback from "@/components/error-feedback";

export default {
  name: "m-doctype-sidesheet",

  components: {
    "c-input-2": Input2,
    "c-textarea": Textarea,
    "c-button-2": Button2,
    "document-color": DocumentColor,
    "u-confirm": Confirm,
    ReferenceSidesheet,
    ErrorFeedback,
  },

  data() {
    return {
      active: false,
      id: "",
      submitted: false,
      pending: false,
      isValid: false,

      form: {
        name: "",
        description: "",
        absentColor: "",
        expiredColor: "",
        expiringColor: "",
      },

      savedData: {},
    };
  },

  computed: {
    nameError() {
      return this.form.name.trim() ? null : "Обязательное поле";
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },

  methods: {
    deleteDocumentType() {
      this.$emit("remove-group", { group: this.savedData }, true);
    },
    setData(doctype = {}) {
      this.$refs.description.clear();

      this.form.name = doctype.name || "";
      this.form.description = doctype.description || "";
      this.form.absentColor = doctype.absent_color || "";
      this.form.expiredColor = doctype.expired_color || "";
      this.form.expiringColor = doctype.expiring_color || "";
    },

    open(params) {
      params = params || {};
      const doctype = params.doctype || {};
      this.id = doctype.id;
      this.savedData = doctype;

      this.setData(doctype);
      this.active = true;

      this.$refs.modal.open();
    },

    close() {
      this.active = false;
      this.savedData = {};
      this.setData();
      this.$refs.modal.close();
    },

    validate() {
      let isValid = true;
      if (this.nameError) isValid = false;

      ["absentColor", "expiredColor", "expiringColor"].forEach((key) => {
        if (!this.$refs[key].isValid) isValid = false;
      });

      return isValid;
    },

    onSubmit() {
      this.submitted = true;
      if (!this.validate()) {
        return false;
      }

      this.submitted = false;
      this.pending = true;

      const action = this.id ? "documents/updateDocumentType" : "documents/addDocumentType";
      const params = {
        data: this.getParams(),
      };
      if (this.id) params.id = this.id;

      this.$store.dispatch(action, params).then(() => {
        this.pending = false;
        this.$emit("update");
        this.close();
      });
      return true;
    },

    getParams() {
      return {
        name: this.form.name,
        description: this.form.description,
        absent_color: this.form.absentColor,
        expired_color: this.form.expiredColor,
        expiring_color: this.form.expiringColor,
      };
    },

    onReset() {
      this.setData(this.savedData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

::v-deep .sidesheet__wrapper {
  width: calc(100vw - 161px);
  padding: 38px 14px 38px 31px;

  @media screen and (max-width: 1024px) {
    width: calc(100vw - 62px);
  }

  @media screen and (max-width: 700px) {
    padding: 28px 20px;
    max-width: 100%;
    width: 100%;
  }
}

::v-deep .sidesheet__actions {
  @media (min-width: 768px) {
    margin-right: 13px;
  }
}

::v-deep .sidesheet__content {
  @include onlyExtraSmall {
    padding-bottom: 40px;
    overflow-y: auto;
  }
}

.documents-group__remove {
  margin-right: 0;
}

.doctype-form {
  margin-top: 32px;

  @include onlyExtraSmall {
    margin-top: 18px;
  }

  &__name {
    margin-bottom: 40px;
  }

  &__name,
  &__description {
    max-width: 565px;
    @include mobileAndTablet {
      max-width: none;
      margin-right: 20px;
    }
    @include onlyExtraSmall {
      margin-right: 0;
    }
  }

  &-issues {
    margin-top: 40px;

    h2 {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
      @include onlyExtraSmall {
        font-size: 15px;
      }
    }

    &__colors {
      display: flex;

      @include onlyExtraSmall {
        flex-direction: column;
      }
    }

    &__color {
      margin-right: 28px;

      @include onlyExtraSmall {
        margin-bottom: 25px;
      }
    }
  }

  &__reset {
    margin-right: 10px;
    width: 120px;
    padding: 0;
  }

  &__save {
    width: 125px;
    padding: 0;
  }
}

@media (max-width: 480px) {
  ::v-deep .sidesheet__header {
    margin-top: -10px;
  }
  .doctype-modal {
    position: relative;
  }
  .doctype-form__actions {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .doctype-form__actions button {
    width: 50%;
    margin: 0;
    border-radius: 0;
  }
}
.layout-header-action {
  display: flex;
}
</style>
